// extracted by mini-css-extract-plugin
export var buttons = "DiscountBanner-module--buttons--28390";
export var componentWrapper = "DiscountBanner-module--componentWrapper--cbf62";
export var container = "DiscountBanner-module--container--95670";
export var contentWrapper = "DiscountBanner-module--contentWrapper--a57ac";
export var contentWrappers = "DiscountBanner-module--contentWrappers--891e5";
export var countDownNumber = "DiscountBanner-module--countDownNumber--418b7";
export var countDownText = "DiscountBanner-module--countDownText--0c280";
export var countdown = "DiscountBanner-module--countdown--00ba6";
export var countdownTimeContainer = "DiscountBanner-module--countdownTimeContainer--f5673";
export var cta = "DiscountBanner-module--cta--e3e22";
export var customCTAButton = "DiscountBanner-module--customCTAButton--5e569";
export var defaultmessage = "DiscountBanner-module--defaultmessage--fe9f3";
export var picture = "DiscountBanner-module--picture--e5494";
export var promotionBanner = "DiscountBanner-module--promotionBanner--f7743";
export var promotionTimeContainer = "DiscountBanner-module--promotionTimeContainer--f83bb";
export var timerBanner = "DiscountBanner-module--timerBanner--c58dd";
export var verticalCenter = "DiscountBanner-module--verticalCenter--c5719";